import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSkypeforbusinessComponent } from './simple-icons-skypeforbusiness.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSkypeforbusinessComponent ],
    exports:      [ SimpleIconsSkypeforbusinessComponent ],
    bootstrap:    []
})
export class SimpleIconsSkypeforbusinessModule {}
